import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import {
    ICheckpoint2AnswerModel,
    ICheckpointGroup,
    ICheckpointUnitSettingModel,
} from '@fi-shared/checklist/checklist-v2';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-checklist2-viewer-checkpoint-group',
    templateUrl: './checkpoint-group.component.html',
    styleUrls: ['./checkpoint-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-viewer-checkpoint-group' },
    providers: [{ provide: FiComponentsContainer, useExisting: FiChecklist2ViewerCheckpointGroupComponent }],
    standalone: false,
})
export class FiChecklist2ViewerCheckpointGroupComponent extends FiComponentsContainer {
    @Input() viewerDisabled: boolean;
    @Input() checkpointGroup: ICheckpointGroup;
    @Input() checkpointAnswersMap: { [checkpointId: number]: ICheckpoint2AnswerModel };
    @Input() checklistViewerPeriodId: number;
    @Input() highlightedCheckpointIds: number[];
    @Input() isQRCodeEnabled: boolean;
    @Input() checkpointUnitSettingsMap: { [checkpointId: number]: ICheckpointUnitSettingModel };
    @Input({ required: true }) hasAccessToSchedule: boolean;
    @Input({ required: true }) auditMode: boolean;
    @Input() isPreviewMode: boolean;
    @Output() answerChanged = new EventEmitter<ICheckpoint2AnswerModel>();
    @Output() invalidMediaBankFileIdsChange = new EventEmitter<number[]>();

    constructor(private appTextService: AppTextService) {
        super();
    }

    isHighlighted(checkpointId: number): boolean {
        return this.highlightedCheckpointIds?.includes(checkpointId);
    }

    getCheckpointGroupName(): string {
        return this.checkpointGroup.Name ? this.checkpointGroup.Name : this.appTextService.get('checklist.checkpoints');
    }

    onAnswerChanged(answer: ICheckpoint2AnswerModel) {
        this.answerChanged.emit(answer);
    }

    onInvalidMediaBankFileIdsChanged($event: number[]) {
        this.invalidMediaBankFileIdsChange.emit($event);
    }
}
